// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"129":"0bc646db","899":"a094bf86"}[chunkId] + ".css";
};